// extracted by mini-css-extract-plugin
export default {"homeButton":"EnchantedFountain_homeButton__eGlLo","mapButton":"EnchantedFountain_mapButton__+sQIP","button":"EnchantedFountain_button__uOGWj"};